<template>
<div class="page-wrapper">
	<div class="page page-settings">
		<div class="container">
			<div class="page-header">
				<h1 class="page-title">
					<router-link class="text" to="/settings">Settings</router-link>
					<i class="separator material-icons">chevron_right</i>
					<span class="page-breadcrumb">Autoresponder</span>
				</h1>
			</div>
			<div class="page-content">
				<div class="box p-0">
					<!-- GetResponse -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<img src="/images/logo-small-getresponse.png" alt="GetResponse">
								</div>
								<button
									type="button"
									class="integration-app-button btn btn-primary"
									@click="isShowModalGetResponse = true"
									v-if="getResponseAccounts.length === 0">
									+ Add GetResponse Account
								</button>
							</div>
						</div>
						<integration-accounts
							:name="'GetResponse Accounts'"
							:accounts="getResponseAccounts"
							@remove="removeIntegration">
						</integration-accounts>
					</div>
					<!-- KirimEmail -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<img src="/images/logo-small-kirimemail.png" alt="KirimEmail">
								</div>
								<button
									type="button"
									class="integration-app-button btn btn-primary"
									@click="isShowModalKirimEmail = true"
									v-if="kirimEmailAccounts.length === 0">
									+ Add KirimEmail Account
								</button>
							</div>
						</div>
						<integration-accounts
							:name="'KirimEmail Accounts'"
							:accounts="kirimEmailAccounts"
							@remove="removeIntegration">
						</integration-accounts>
					</div>
					<!-- MailChimp -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<img src="/images/logo-small-mailchimp.png" alt="MailChimp">
								</div>
								<button
									type="button"
									class="integration-app-button btn btn-primary"
									@click="isShowModalMailChimp = true"
									v-if="mailChimpAccounts.length === 0">
									+ Add MailChimp Account
								</button>
							</div>
						</div>
						<integration-accounts
							:name="'MailChimp Accounts'"
							:accounts="mailChimpAccounts"
							@remove="removeIntegration">
						</integration-accounts>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modals">
		<!-- GetResponse -->
		<modal class="integration-modal" :size="'medium'" v-if="isShowModalGetResponse" @close="isShowModalGetResponse = false">
			<div slot="header"><h3>GetResponse</h3></div>
			<div slot="body" class="text-center">
				<h5 class="modal-title">How to Integrate</h5>
				<div class="integration-video embed-responsive embed-responsive-16by9">
					<iframe src="https://www.youtube.com/embed/4r9ndzoaWBs?rel=0"></iframe>
				</div>
				<div class="integration-actions">
					<div class="input-group">
						<input type="text" class="input form-control" placeholder="GetResponse API Key" v-model="getResponseApiKey">
						<div class="input-group-append">
							<button
								type="button"
								class="input-group-text btn btn-primary"
								:disabled="getResponseApiKey.length === 0"
								:class="{ 'is-loading': isAddingGetResponse }"
								@click="addGetResponse">
								Integrate
							</button>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-light" @click="isShowModalGetResponse = false">{{ $t('Close') }}</button>
			</div>
		</modal>

		<!-- KirimEmail -->
		<modal class="integration-modal" :size="'medium'" v-if="isShowModalKirimEmail" @close="isShowModalKirimEmail = false">
			<div slot="header"><h3>KirimEmail</h3></div>
			<div slot="body" class="text-center">
				<h5 class="modal-title">How to Integrate</h5>
				<div class="integration-video embed-responsive embed-responsive-16by9">
					<iframe src="https://www.youtube.com/embed/yC9_wFyaB_Q?rel=0"></iframe>
				</div>
				<div class="integration-actions">
					<div class="form-group">
						<input type="text" class="input form-control" placeholder="KirimEmail Username" v-model="kirimEmailUsername">
					</div>
					<div class="form-group">
						<input type="text" class="input form-control" placeholder="KirimEmail API Token" v-model="kirimEmailApiKey">
					</div>
					<div class="text-right">
						<button
							type="button"
							class="btn btn-primary"
							:disabled="kirimEmailUsername.length === 0 || kirimEmailApiKey.length === 0"
							:class="{ 'is-loading': isAddingKirimEmail }"
							@click="addKirimEmail">
							Integrate
						</button>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-light" @click="isShowModalKirimEmail = false">{{ $t('Close') }}</button>
			</div>
		</modal>

		<!-- MailChimp -->
		<modal class="integration-modal" :size="'medium'" v-if="isShowModalMailChimp" @close="isShowModalMailChimp = false">
			<div slot="header"><h3>MailChimp</h3></div>
			<div slot="body" class="text-center">
				<h5 class="modal-title">How to Integrate</h5>
				<div class="integration-video embed-responsive embed-responsive-16by9">
					<iframe src="https://www.youtube.com/embed/xCJhtsHcaQs?rel=0"></iframe>
				</div>
				<div class="integration-actions">
					<div class="input-group">
						<input type="text" class="input form-control" placeholder="MailChimp API Key" v-model="mailChimpApiKey">
						<div class="input-group-append">
							<button
								type="button"
								class="input-group-text btn btn-primary"
								:disabled="mailChimpApiKey.length === 0"
								:class="{ 'is-loading': isAddingMailChimp }"
								@click="addMailChimp">
								Integrate
							</button>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-light" @click="isShowModalMailChimp = false">{{ $t('Close') }}</button>
			</div>
		</modal>
	</div>

	<notifications group="autoresponder" position="bottom right" />
</div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';
import Modal from '../components/Modal.vue';
import IntegrationAccounts from '../components/IntegrationAccounts.vue';
import integrationApi from '../api/integration';

export default {
	name: 'settingsAutoresponder',
	components: {
		Modal,
		IntegrationAccounts,
	},
	data() {
		return {
			isShowModalMailChimp: false,
			isShowModalGetResponse: false,
			isShowModalKirimEmail: false,
			isAddingMailChimp: false,
			isAddingGetResponse: false,
			isAddingKirimEmail: false,
			mailChimpApiKey: '',
			getResponseApiKey: '',
			kirimEmailApiKey: '',
			kirimEmailUsername: '',
		};
	},
	methods: {
		...mapActions({
			fetchAccounts: 'settings/fetchAccounts',
			addAccount: 'settings/addAccount',
			removeAccount: 'settings/removeAccount',
		}),
		removeIntegration(id) {
			this.removeAccount(id);
			const callback = (response) => {
				// console.log(response);
			};
			integrationApi.remove(id, callback);
		},
		addMailChimp() {
			this.isAddingMailChimp = true;
			const apiKey = this.mailChimpApiKey;
			const params = { api_key: apiKey };
			const callback = (response) => {
				const account = response.data;
				if (account !== '') {
					this.addAccount(account);
				}
				this.mailChimpApiKey = '';
				this.isAddingMailChimp = false;
				this.isShowModalMailChimp = false;

				this.$notify({
					group: 'autoresponder',
					title: 'Autoresponder',
					text: 'Successfully Connected to MailChimp',
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				if (e.response) {
					const response = e.response.data;
					const errorMessage = response.message;
					this.$notify({
						group: 'autoresponder',
						title: 'Autoresponder',
						text: errorMessage,
						type: 'error',
					});
				}
				this.isAddingMailChimp = false;
			};
			integrationApi.addMailChimp(params, callback, errorCallback);
		},
		addGetResponse() {
			this.isAddingGetResponse = true;
			const apiKey = this.getResponseApiKey;
			const params = { api_key: apiKey };
			const callback = (response) => {
				const account = response.data;
				if (account !== '') {
					this.addAccount(account);
				}
				this.getResponseApiKey = '';
				this.isAddingGetResponse = false;
				this.isShowModalGetResponse = false;

				this.$notify({
					group: 'autoresponder',
					title: 'Autoresponder',
					text: 'Successfully Connected to GetResponse',
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				if (e.response) {
					const response = e.response.data;
					const errorMessage = response.message;
					this.$notify({
						group: 'autoresponder',
						title: 'Autoresponder',
						text: errorMessage,
						type: 'error',
					});
				}
				this.isAddingGetResponse = false;
			};
			integrationApi.addGetResponse(params, callback, errorCallback);
		},
		addKirimEmail() {
			this.isAddingKirimEmail = true;
			const username = this.kirimEmailUsername;
			const apiKey = this.kirimEmailApiKey;
			const params = { username: username, api_key: apiKey };
			const callback = (response) => {
				const account = response.data;
				if (account !== '') {
					this.addAccount(account);
				}
				this.kirimEmailApiKey = '';
				this.kirimEmailUsername = '';
				this.isAddingKirimEmail = false;
				this.isShowModalKirimEmail = false;

				this.$notify({
					group: 'autoresponder',
					title: 'Autoresponder',
					text: 'Successfully Connected to KirimEmail',
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				if (e.response) {
					const response = e.response.data;
					const errorMessage = response.message;
					this.$notify({
						group: 'autoresponder',
						title: 'Autoresponder',
						text: errorMessage,
						type: 'error',
					});
				}
				this.isAddingKirimEmail = false;
			};
			integrationApi.addKirimEmail(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			isFetching: 'settings/isFetching',
			accounts: 'settings/accounts',
		}),
		mailChimpAccounts() {
			return this.accounts.filter(account => account.name === 'mailchimp');
		},
		getResponseAccounts() {
			return this.accounts.filter(account => account.name === 'get_response');
		},
		kirimEmailAccounts() {
			return this.accounts.filter(account => account.name === 'kirimemail');
		},
	},
	created() {
		if (!this.isFetching) {
			this.fetchAccounts();
		}
	},
};
</script>
